import { completeName, dateDiffWithTodayDetail, i18n } from '../../utils';

export const normalizeDataTableDevices = (payload: any) => {
  const data = payload?.item?.items;
  // const result = data?.filter((item: any) => item.type.code !== 'HUB2');
  return data ? data.map((item: any) => ({
    id: item.id,
    serialNo: item.serialNo,
    hwSerialNo: item.hwSerialNo,
    type: item.type.code,
    lastConnection:  i18n("device.status.lastConnection") + " " + dateDiffWithTodayDetail(item.lastConnection),
    user: completeName(item.deviceGeneral?.patients[0]?.firstName, item.deviceGeneral?.patients[0]?.middleName, item.deviceGeneral?.patients[0]?.lastName),
    userId: item.deviceGeneral?.patients[0]?.id,
    status: item.status,
    peripherals: item.peripherals,
    group: item.group.code,
    patientServiceNumber: item.deviceGeneral?.patients[0]?.serviceNumber,
  })) : [];
}
